import { useState } from 'react';
import { ContinueButton, RequiredNote } from './common.jsx';

// Tap-to-select chips of the 20 most common US supplements + a free-text "add your
// own". Selection is stored as an array under the NEW `supplements` field. The
// question is required, so — like a required text box answered "none" — the client
// must either pick something or explicitly say they take none ("None" sentinel).
const NONE = 'None';

export default function SupplementPicker({ item, answers, setAnswer, onAdvance }) {
  const fieldId = item.new_field || 'supplements';
  const selected = Array.isArray(answers[fieldId]) ? answers[fieldId] : [];
  const [custom, setCustom] = useState('');

  const noneSelected = selected.includes(NONE);
  const incomplete = item.required && selected.length === 0;
  // Custom entries not in the catalog still need chips to render (never the sentinel).
  const catalog = item.options || [];
  const extras = selected.filter((s) => s !== NONE && !catalog.includes(s));
  const chips = [...catalog, ...extras];

  const toggle = (name) => {
    const base = selected.filter((s) => s !== NONE); // picking a real one clears "none"
    const next = base.includes(name) ? base.filter((n) => n !== name) : [...base, name];
    setAnswer(fieldId, next);
  };
  const addCustom = () => {
    const v = custom.trim();
    if (!v) { setCustom(''); return; }
    const base = selected.filter((s) => s !== NONE && s !== v);
    setAnswer(fieldId, [...base, v]);
    setCustom('');
  };
  const toggleNone = () => setAnswer(fieldId, noneSelected ? [] : [NONE]);

  return (
    <>
      <h1>{item.label}</h1>
      <p className="sub">Select all that apply, or add your own below.</p>
      <div className="chipwrap">
        {chips.map((name) => (
          <button key={name} className={`chip${selected.includes(name) ? ' on' : ''}`} onClick={() => toggle(name)}>
            {selected.includes(name) ? '✓ ' : ''}<span>{name}</span>
          </button>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 16, maxWidth: 400 }}>
        <input
          className="win"
          placeholder="Add another supplement…"
          value={custom}
          onChange={(e) => setCustom(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addCustom(); } }}
        />
        <button
          onClick={addCustom}
          style={{ padding: '0 18px', border: '1px solid var(--line)', borderRadius: 10, background: '#fff', color: 'var(--coral)', cursor: 'pointer', whiteSpace: 'nowrap', fontFamily: 'inherit' }}
        >
          Add
        </button>
      </div>
      <button
        type="button"
        className={`chip nonechip${noneSelected ? ' on' : ''}`}
        style={{ marginTop: 14 }}
        onClick={toggleNone}
      >
        {noneSelected ? '✓ ' : ''}<span>I don’t take any supplements</span>
      </button>
      {incomplete && <RequiredNote />}
      <div className="spacer" />
      <ContinueButton onClick={onAdvance} disabled={incomplete} />
    </>
  );
}
